<template>
  <div id="content" class="content" style="margin-left:0px;">
    <h1 class="page-header" style="text-align:left">
      服务商订单管理
      <small>/商品采购下单</small>
    </h1>
    <div
      id="page-container"
      class="in page-sidebar-fixed page-header-fixed"
      style="padding-top:0px;"
    >
      <!-- begin #content -->
      <div
        id="content"
        class="content"
        style="margin-left:0px;padding-top: 0px;padding-left:0px;padding-right:0px;"
      >
        <!-- begin breadcrumb -->
        <div class="row">
          <!-- begin col-10 -->
          <div class="col-lg-12">
            <!-- begin panel -->
            <div class="panel panel-inverse">
              <!-- begin panel-heading -->
              <div class="panel-heading">
                <div class="panel-heading-btn">
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-default"
                    data-click="panel-expand"
                  >
                    <i class="fa fa-expand"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-success"
                    data-click="panel-reload"
                  >
                    <i class="fa fa-redo"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-warning"
                    data-click="panel-collapse"
                  >
                    <i class="fa fa-minus"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-danger"
                    data-click="panel-remove"
                  >
                    <i class="fa fa-times"></i>
                  </a>
                </div>
                <h4 class="panel-title panelTitle">供应商商品管理</h4>
              </div>
              <!-- end panel-heading -->
              <el-card class="box-card">
                <div>
                  <div class="top-hd">
                    <el-row>
                      <el-form
                        ref="form"
                        :model="form"
                        label-width="110px"
                        style="width: 70%;font-size:12px;color:#242a30;"
                      >
                        <el-col :span="8">
                          <div class="grid-content bg-purple-light">
                            <el-form-item label="订单编号" class="btn1">
                              <el-input
                                v-model="form.orderNo"
                                class="top-input"
                                placeholder="请输入订单编号"
                              ></el-input>
                            </el-form-item>
                          </div>
                        </el-col>
                        <el-col :span="8">
                          <div class="grid-content bg-purple-light">
                            <el-form-item label="商品名称" class="btn1">
                              <el-input
                                v-model="form.goodsName"
                                class="top-input"
                                placeholder="请输入商品名称"
                              ></el-input>
                            </el-form-item>
                          </div>
                        </el-col>
                        <el-col :span="8">
                          <div class="grid-content bg-purple-light" style>
                            <el-form-item label="订单状态" class="btn1">
                              <el-select
                                v-model="form.orderStatus"
                                style="width:100%"
                                clearable
                                filterable
                                placeholder="请输入订单状态"
                                class="top-input"
                              >
                                <el-option
                                  v-for="item in orderStatusList"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value"
                                ></el-option>
                              </el-select>
                            </el-form-item>
                          </div>
                        </el-col>
                      </el-form>
                    </el-row>
                  </div>

                  <div class="top-bot">
                    <el-form ref="Formdata" :model="Formdata" :rules="rules" label-width="130px">
                      <el-form-item label="订单时间" prop="TimeValue">
                        <el-date-picker
                          v-model="Formdata.TimeValue"
                          type="datetimerange"
                          range-separator="-"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          @change="ChangePicker"
                          align="center"
                          class="top-input"
                          style="width:240px;"
                        ></el-date-picker>
                      </el-form-item>
                    </el-form>
                  </div>
                  <div class="bot-btn">
                    <el-button
                      class="btn btn-primary btn-sm ButtonColor a_class"
                      @click="chaxun()"
                    >查询</el-button>
                  </div>
                  <div class="bot-btn_right">
                    <el-button
                      class="btn btn-primary btn-sm ButtonColor m-l-1 a_class"
                      @click="AddClick()"
                    >下单</el-button>
                    <!-- <el-button
                       class=" btn btn-primary btn-sm ButtonColor m-l-1 a_class  bot-btn-left"
                      @click="exp()"
                    >批量导入</el-button>-->
                  </div>
                  <div class="div_table">
                    <el-form :model="tableForm" ref="tableForm">
                      <el-table
                        class="bankTable"
                        :data="tableForm.tableData3"
                        border
                        :header-cell-style="{background:'#ffffff'}"
                        style="width: 100%;"
                        @selection-change="handleSelectionChange"
                      >
                        <el-table-column type="selection" width="55"></el-table-column>

                        <el-table-column
                          width="80"
                          prop="goodsid"
                          label="序号"
                          align="center"
                          resizable
                        ></el-table-column>
                        <el-table-column
                          width="200"
                          prop="companyName"
                          label="企业名称"
                          align="center"
                          resizable
                        ></el-table-column>
                        <el-table-column
                          width="150"
                          prop="brandName"
                          label="品牌"
                          align="center"
                          resizable
                        ></el-table-column>

                        <el-table-column
                          width="150"
                          prop="seriesName"
                          label="系列"
                          align="center"
                          resizable
                        ></el-table-column>
                        <el-table-column
                          width="500"
                          prop="goodsName"
                          label="商品名称"
                          align="center"
                          resizable
                        ></el-table-column>
                        <el-table-column align="center" resizable label="采购数量">
                          <template slot-scope="scope">
                            <el-form-item
                              :prop="`tableData3.${scope.$index}.detailCount`"
                              :rules="tableRules.detailCount"
                            >
                              <el-input
                                v-model="scope.row.detailCount"
                                :disabled="scope.row.search"
                              ></el-input>
                            </el-form-item>
                          </template>
                        </el-table-column>
                      </el-table>
                    </el-form>
                  </div>
                  <!-- 04 -->
                  <div class="bottom">
                    <div class="block">
                      <!---- totalCount  ------- pageSize   ----->
                      <el-pagination
                        :current-page="pageNo"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[10, 20, 50]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="totalCount"
                        background
                      ></el-pagination>
                    </div>
                  </div>
                     <div class="goback">
                    <el-button
                      class="btn btn-primary btn-sm ButtonColor a_class"
                      @click="goback()"
                    >返回</el-button>
                  </div>
                </div>
              </el-card>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Qs from "qs";
import axios from "axios";
import http from "../../common/http";
import MethodsBus from "../../common/methodBus";
import eventBus from "../../common/eventBus";
import { error } from "util";
export default {
  name: "productListadd",
  data() {
    var checkdetailCount = (rule, value, callback) => {
      setTimeout(() => {
        let reg = /^[1-9]\d*|0$/g;
        reg.test(value) ?  callback() : callback(new Error("采购数量格式不正确"));
      }, 1000);
    };
    return {
      tableForm: {
        tableData3: []
      },
      tableRules: {
        detailCount: [
          { required: true, message: "请输采购数量" },
          { validator: checkdetailCount, trigger: ["change", "blur"] }
        ]
      },
      fileList: [],
      imgVisible: false,
      dialogImgUrl: "",
      // 显示 隐藏   按钮  数据
      hiddenbutton: "",
      // 对话框
      outerVisible: false,
      DialogTitle: "编辑",
      disabled: false,
      EditDialog: 1,
      ruleForm: {},
      CurrentSelection: [],
      // 当前页  ---- 默认显示第几页
      // current: 1,
       director:0,
      pageNo: 1,
      // 当前显示 数据的数据量
      pageSize: 10,
      // 数据总数量  ---- 总条数
      totalCount: 0,
      // 上传合同，
      fileformData: {},
      dialogImageUrl: "",
      dialogVisible: false,
      // 缴纳凭证
      // 开始时间  （yyyy-MM-dd HH:mm:ss）
      startTime: "",
      // 结束时间  （yyyy-MM-dd HH:mm:ss）
      endTime: "",
      form: {
        //合同编号
        contractNo: "",
        // 合同标题
        contractTitle: "",
        recomName: "",
        orderStatus: ""
      },
      orderStatusList: [
        {
          value: "选项1",
          label: "待财务审核"
        },
        {
          value: "选项2",
          label: "待运营审核"
        },
        {
          value: "选项3",
          label: "财务审核不通过"
        },
        {
          value: "选项4",
          label: "运营审核不通过"
        },
        {
          value: "选项5",
          label: "运营审核"
        },
        {
          value: "选项6",
          label: "财务审核"
        }
      ],
      // 列表服务商名称
      recomNameList: [],
      // 新增 编辑  数据
      ruleForm: {
        contractNo: "",
        // 编辑的服务商
        recomName1: "",
        //  缴纳时间
        depositTime: "",
        // 保障金额
        deposit: ""
      },
      rules: {},
      Formdata: {
        TimeValue: ""
      },
      //   表格的 数据
      tableData3: [],
      multipleSelection: [],

      datalist: {
        orderInfos: [{}],
        director: ""
      }
    };
  },
  created() {
    this.initData();
  },
  mounted() {
    // if(this.$route.query.director){
    //   this.director = this.$route.query.director;
    // }
  },
  methods: {
    // 初始化数据
    initData() {
      let that = this;
      const options = {
        url: "/distribution/B2cTobOrderController/queryAddOrderInfo",
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        // 请求参数
        data: Qs.stringify({
          director: that.director
        })
      };
      axios(options).then(response => {
        if (response.data.code == 200) {
          for (var i = 0; i < response.data.data.records.length; i++) {
            //  goodsid  为  自定义  属性 --- 【序号】
            response.data.data.records[i].goodsid =
              Number((that.pageNo - 1) * that.pageSize) + Number(i) + 1;
          }
          if (response.data.data.records.length > 0) {
            for (var value of response.data.data.records) {
              value.depositScope = value.province + " " + value.city;
            }
            this.tableForm.tableData3 = response.data.data.records;
            this.totalCount = response.data.data.total;
          }
        } else {
          that.$notify({
            title: "失败",
            message: response.data.message,
            type: "error"
          });
        }
      });
    },

    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(_ => {
          done();
        })
        .catch(_ => {});
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.datalist.orderInfos = val;
      localStorage.setItem("userList", JSON.stringify(this.datalist));
    },
    //  删除合同
    handleRemove(file, fileList) {
    },
    handlePictureCardPreview(file) {
     
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleSuccess(response, file, fileList) {

    },
    //
    openImg(url) {
      if (url) {
        this.imgVisible = true;
        this.dialogImgUrl = url;
      }
    },

    //  覆盖默认上传行为
    httpRequest(param) {
      this.dialogImageUrl = URL.createObjectURL(param.file);
      let fd = new FormData();
      fd.append("file", param.file);
     
    },

    //   列表中的  上传凭证
    uploadPicture(param) {
      this.dialogImageUrl = URL.createObjectURL(param.file);
      const formData = new FormData();
      formData.append("file", param.file);
      this.fileformData = formData;
    },
    // 查询数据
    chaxun() {
      this.pageNo  = 1;
      this.initData();
    },
    // 新增
    AddClick() {
      this.$refs["tableForm"].validate(valid => {
        if (valid) {
          let that = this;
          const options = {
            url: "/distribution/B2cTobOrderController/addorder",
            method: "post",
            headers: { "Content-Type": "application/json" },
            data: localStorage.getItem("userList")
          };
          axios(options)
            .then(function(response) {
              if (response.data.code == 200) {
                that.$router.push({
                  path: "/topadd",
                  query: { data: JSON.stringify(response.data.data) }
                });
              } else {
                http.handleEorrorCode(response, that);
              }
            })
            .catch(function(error) {
             http.handleHttpError(error, that);
            });
        } else {
          localStorage.removeItem("userList");
          this.$notify.error({
            title: "错误",
            message: "请先输入采购数量再勾选商品下单"
          });
        }
      });
    },
    MakeSureEdit(formName) {
      let that = this;
      if (this.DialogTitle === "编辑") {
        that.$refs[formName].validate(valid => {
          if (valid) {
            that.disabled = true;
            const options = {
              url: "/distribution/B2cTobDepositController/editDeposit",
              method: "post",
              headers: { "Content-Type": "application/x-www-form-urlencoded" },
              data: Qs.stringify({
                // 合同编号
                contractNo: that.ruleForm.contractNo,
                // 保障金
                deposit: that.ruleForm.deposit,
                // 缴纳时间
                depositTime: that.ruleForm.depositTime,

                fileUrl: that.dialogImageUrl
              })
            };
            axios(options)
              .then(function(response) {
                if (response.data.code == 200) {
                  that.outerVisible = false;
                  that.disabled = false;
                  that.initData();
                  that.$notify({
                    title: "成功",
                    message: "编辑成功",
                    type: "success"
                  });
                } else {
                  http.handleEorrorCode(response, that);
                }
              })
              .catch(function(error) {
                that.outerVisible = false;
                that.disabled = false;
                http.handleHttpError(error, that);
              });
          } else {
            this.outerVisible = true;
          }
        });
      } else if (this.DialogTitle === "新增") {
        that.$refs[formName].validate(valid => {
          if (valid) {
            that.disabled = true;
            const options = {
              url: "/distribution/B2cTobDepositController/addDeposit",
              method: "post",
              headers: { "Content-Type": "application/x-www-form-urlencoded" },
              data: Qs.stringify({
                // 合同编号
                contractNo: that.ruleForm.contractNo,
                // 保障金
                deposit: that.ruleForm.deposit,
                // 缴纳时间
                depositTime: that.ruleForm.depositTime,
                fileUrl: that.dialogImageUrl
              })
            };
            axios(options)
              .then(function(response) {
                if (response.data.code == 200) {
                  that.outerVisible = false;
                  that.disabled = false;
                  that.initData();
                  that.$notify({
                    title: "成功",
                    message: "新增成功",
                    type: "success"
                  });
                } else {
                  http.handleEorrorCode(response, that);
                }
              })
              .catch(function(error) {
                that.outerVisible = false;
                that.disabled = false;
                http.handleHttpError(error, that);
              });
          } else {
            this.outerVisible = true;
          }
        });
      } else if (this.DialogTitle === "上传凭证") {
        let that = this;
        const options = {
          url: "distribution/FileController/uploadFileToFast",
          method: "post",
          headers: { "Content-Type": "multipart/form-data" },
          data: that.fileformData
        };
        axios(options)
          .then(function(response) {
            if (response.data.code == 200) {
              for (var value of that.tableData3) {
                value.fileUrl = response.data.data;
              }
              // that.initData()

              that.$notify({
                title: "",
                message: response.data.message,
                type: "success"
              });
              that.outerVisible = false;
            
              setTimeout(() => {
                that.percentage = 100;
                that.percentagestatus = "success";
              }, 100);
            } else {
              http.handleEorrorCode(response, that);
            }
          })
          .catch(function(error) {
            http.handleHttpError(error, that);
          });

      }
    },
   goback() {
      this.$router.push({ path: "/productList" });
      localStorage.removeItem("userList")
    },
    // 导出数据
    exp() {
      let that = this;
      const options = {
        url: "/statistics/purchaseController/queryExcelPurchaseInfo",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        // 请求参数
        data: Qs.stringify({
          goodName: that.form.goodsName,
          pznCode: that.form.pznCode,
          barCode: that.form.barCode,
          //  开始时间
          beginTime: that.startTime,
          // 结束时间  （yyyy-MM-dd HH:mm:ss）
          endTime: that.endTime
        })
      };
      axios(options)
        .then(function(response) {
          if (response.data.code == 200) {
            that.$notify({
              title: "成功",
              message: response.data.message,
              type: "success"
            });
          }
        })
        .catch(error => {
          http.handleHttpError(error, this);
        });
    },

    // 删除的 处理函数
    del(item) {
      //console.log(row);
      this.outerVisible = true;
      this.EditDialog = 2;
      this.CurrentSelection = item;
    },
    // 编辑函数
    edit(row) {
      this.outerVisible = true;
      this.DialogTitle = "编辑";
      this.EditDialog = 1;
      if (this.$refs["ruleForm"]) {
        this.$refs["ruleForm"].resetFields();
      }
      this.ruleForm = MethodsBus.cloneRow(row);
    },
    // 对话框删除的  处理函数  ------ 【确定 按钮】
    MakeSure() {
      let that = this;
      that.disabled = true;
      console.log(that.CurrentSelection);
      const options = {
        url: "/distribution/B2cTobDepositController/deleteDeposit",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
          depositId: that.CurrentSelection.depositId
        })
      };
      axios(options)
        .then(response => {
          that.outerVisible = false;
          that.disabled = false;
          if (response.data.code == 200) {
            console.log(that.CurrentSelection.depositId);
            that.initdata();
            that.$notify({
              title: "成功",
              message: "删除成功",
              type: "success"
            });
          } else {
            http.handleEorrorCode(response, that);
          }
        })
        .catch(function(error) {
          that.disabled = false;
          http.handleHttpError(error, that);
        });
    },
    //   startTime  开始时间
    getstarttime() {
      var now = new Date();
      var year = now.getFullYear(); //得到年份
      var month = now.getMonth() + 1; //得到月份
      var date = now.getDate(); //得到日期
      //   var day = now.getDay(); //得到周几
      var hour = now.getHours(); //得到小时
      var minu = now.getMinutes(); //得到分钟
      var sec = now.getSeconds(); //得到秒

      if (now.getMonth() + 1) {
        if (month < 10) month = "0" + (now.getMonth() + 1);
        date = "0" + "1";
        hour = "0" + "0";
        minu = "0" + "0";
        sec = "0" + "0";
      }
      var time = "";
      time =
        year + "-" + month + "-" + date + " " + hour + ":" + minu + ":" + sec;
      return time;
    },
    // endtime;结束时间
    getEndtime() {
      var now = new Date();
      var year = now.getFullYear(); //得到年份
      var month = now.getMonth(); //得到月份
      var date = now.getDate(); //得到日期
      var day = now.getDay(); //得到周几
      var hour = now.getHours(); //得到小时
      var minu = now.getMinutes(); //得到分钟
      var sec = now.getSeconds(); //得到秒
      month = month + 1;
      if (month < 10) month = "0" + month;
      if (date < 10) date = "0" + date;
      if (hour < 10) hour = "0" + hour;
      if (minu < 10) minu = "0" + minu;
      if (sec < 10) sec = "0" + sec;
      var time = "";
      time =
        year + "-" + month + "-" + date + " " + hour + ":" + minu + ":" + sec;
      return time;
    },
    //  时间的处理函数
    ChangePicker() {
      if (this.Formdata.TimeValue) {
        this.startTime = this.FormatAllDate(this.Formdata.TimeValue[0]);
        this.endTime = this.FormatAllDate(this.Formdata.TimeValue[1]);
      } else if (!this.Formdata.TimeValue) {
        this.startTime = "";
        this.endTime = "";
      }
    },
    FormatAllDate(sDate) {
      var date = new Date(sDate);
      var seperator1 = "-";
      var seperator2 = ":";
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var seconds = date.getSeconds();
      //月
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      //日
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      //时
      if (hours >= 0 && hours <= 9) {
        hours = "0" + hours;
      }
      //分
      if (minutes >= 0 && minutes <= 9) {
        minutes = "0" + minutes;
      }
      //秒
      if (seconds >= 0 && seconds <= 9) {
        seconds = "0" + seconds;
      }
      //格式化后日期为：yyyy-MM-dd HH:mm:ss
      var currentdate =
        date.getFullYear() +
        seperator1 +
        month +
        seperator1 +
        strDate +
        " " +
        hours +
        seperator2 +
        minutes +
        seperator2 +
        seconds;
      return currentdate;
    },
    FormatAllDateadd() {
      this.ruleForm.depositTime = this.FormatAllDate(this.ruleForm.depositTime);
    },
    // 分页处理函数 分页-- 获取 每页  value条
    handleSizeChange(value) {
      this.pageSize = value;
      this.pageNo = 1;
      this.initData();
    },
    //  获取 当前  value
    handleCurrentChange(value) {
      this.pageNo = value;
      
      this.initData();
    }
  }
};
</script>
<style scoped>
.clear {
  clear: both;
}
.PaginationStyle {
  float: right;
  margin-top: 8px;
}
.left {
  margin-left: 20px;
}
.upload {
  margin-top: 20px;
  margin-left: 13%;
  display: flex;
  justify-content: flex-start;
}
.upload_left {
  padding-right: 30px;
  letter-spacing: 1px;
}
.panelTitle {
  padding-left: 15px;
  text-align: left;
}
.ButtonColor {
  color: #fff !important;
}
.ModelPadding {
  margin-top: -20px;
}
.LineSpacing {
  margin-top: 16px;
}
.InputWidth {
  width: 202px;
}
.top-hd {
  margin-top: 20px;
  margin-left: 0px;
}
.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}

.box-card {
  width: 100%;
}
.goback {
  float: right;
  margin-top: 20px;
  padding-bottom: 20px;
  margin-right: 20px;
}
.inputclass {
  margin-left: 12%;
}
.bottom {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
}
.bottom_table {
  display: flex;
  justify-content: flex-start;
}

.grid-content {
  border-radius: 4px;
  min-height: 20px;
}
.top-thone {
  margin-left: 20px;
  margin-top: 20px;
}
.btn1 {
  background-color: #fff;
  margin-left: 20px;
}
.bot-btn {
  margin-left: 40%;
}
.div_table {
  margin-top: 70px;
}
.bot-btn-left {
  margin-left: 70px;
}
.top-bot {
  float: left;
}
.top-input {
  margin-left: 25px;
}
.a_class {
  padding: 8px 12px;
}
.bot-btn_right {
  float: right;
  margin-right: 30px;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/DistributorManage/productListadd.vue